// Names this app to core on every call, so core's logs and Raygun reports show which app a request came from.
export const CLIENT_APP = 'admin';
